import React, { useState, useEffect } from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'components/Pagination';
import {
  Container,
  Row,
  Card,
  Button,
  Input,
  Col,
  FormGroup,
  CardHeader,
  Label,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import SimpleHeader from '../../../components/Headers/SimpleHeader';
import TemplateService from '../service';
import { BsFillImageFill } from 'react-icons/bs';

import {
  icon_column_style,
  individual_icon_header_style,
  individual_icon_header_style_callback
} from '../../../assets/styles/table_custom_style';
import { Chip } from '@material-ui/core/';
import { ChipContainer } from '../styles';
import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';
import UpdateMedia from '../components/UpdateMedia';

const TemplateList = () => {
  const [activePage, setActivePage] = useState(1);
  const [templates, setTemplates] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDisabled, setShowDisable] = useState(false);
  const [openModalUpdateMedia, setOpenModalUpdateMedia] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState({
    id: null,
    name: ''
  });

  useEffect(() => {
    fetchTemplates();
  }, []);

  useEffect(() => {
    handleOnSearch();
  }, [showDisabled, searchQuery, templates]);

  const fetchTemplates = () => {
    TemplateService.getAllTemplates()
      .then((response) => {
        const data = response?.data || [];
        setTemplates(data);
        setFilteredTemplates(data);
      })
      .catch((err) => console.error('Erro ao carregar templates:', err));
  };

  const handlePageChange = (activePage) => {
    setActivePage(activePage);
  };

  const handleOnSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = templates.filter((template) => {
      const matchesSearch = template.name.toLowerCase().includes(query);
      const matchesStatus = showDisabled ? true : template.isActive;
      return matchesSearch && matchesStatus;
    });
    setFilteredTemplates(filtered);
  };

  const handleToggleChange = async (row) => {
    const newState = !row.isActive;
    try {
      await TemplateService.toggleTemplateStatus(row.id, newState);
      row.isActive = newState;
      setTemplates([...templates]);
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      alert('Erro ao atualizar o status do template. Tente novamente.');
    }
  };

  const handleUpdateMedia = (id, name) => {
    setCurrentTemplate({ id, name });
    setOpenModalUpdateMedia(true);
  };

  const handleMediaUpdate = (id, newMediaUrl) => {
    setTemplates((prevTemplates) =>
      prevTemplates.map((template) =>
        template.id === id ? { ...template, media: newMediaUrl } : template
      )
    );
    setFilteredTemplates((prevFiltered) =>
      prevFiltered.map((template) =>
        template.id === id ? { ...template, media: newMediaUrl } : template
      )
    );
  };

  return (
    <>
      <SimpleHeader name="Template" parentName="Gerenciamento" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Templates</h3>
                </CardHeader>
                <Row className="mt-3 mx-2">
                  <Col md="8">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Buscar template por título"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') handleOnSearch();
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col md="4" className="text-right mt-2 mt-md-1">
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          checked={showDisabled}
                          onChange={() => setShowDisable(!showDisabled)}
                        />
                        <span>Mostrar desabilitados</span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={filteredTemplates}
                  keyField="id"
                  columns={[
                    { dataField: 'name', text: 'Nome', sort: true },
                    {
                      dataField: 'description',
                      text: 'Descrição',
                      sort: true
                    },
                    {
                      dataField: 'type',
                      text: 'Tipo',
                      sort: true
                    },
                    {
                      dataField: 'isActive',
                      text: 'Ativo',
                      formatter: (isActive) => (
                        <ChipContainer>
                          {isActive ? (
                            <Chip
                              className="chipTrue"
                              size="small"
                              label="sim"
                            />
                          ) : (
                            <Chip
                              className="chipFalse"
                              size="small"
                              label="não"
                            />
                          )}
                        </ChipContainer>
                      )
                    },
                    {
                      dataField: 'media',
                      text: 'Imagem',
                      formatter: (_, row) =>
                        row.media ? (
                          <img
                            src={row.media}
                            alt="Template"
                            style={{ maxWidth: '50px', maxHeight: '50px' }}
                          />
                        ) : (
                          <span>Sem Imagem</span>
                        )
                    },
                    {
                      dataField: 'disable',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style_callback,
                      text: 'Habilitar / Desabilitar',
                      formatter: (_, row) => {
                        return (
                          <div>
                            <ToggleSwitch
                              checked={row.isActive}
                              onChange={() => handleToggleChange(row)}
                              id={row.id}
                            />
                          </div>
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar Media',
                      formatter: (_, row) => {
                        const isDisabled = row.type !== 'IMAGE';
                        return (
                          <Button
                            color="success"
                            title="Editar Media"
                            type="button"
                            size="sm"
                            disabled={isDisabled}
                            onClick={() => {
                              if (!isDisabled) {
                                handleUpdateMedia(row.id, row.name);
                              }
                            }}
                          >
                            <BsFillImageFill />
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      <BootstrapTable
                        {...props.baseProps}
                        bootstrap4={true}
                        bordered={false}
                        classes="align-items-center"
                      />
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={filteredTemplates.length}
                  onChange={handlePageChange}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>

      <UpdateMedia
        isModalOpen={openModalUpdateMedia}
        onModalToggle={setOpenModalUpdateMedia}
        templateId={currentTemplate.id}
        templateName={currentTemplate.name}
        onMediaUpdate={handleMediaUpdate}
      />
    </>
  );
};

export default TemplateList;
